import * as React from 'react';
import './AccountContent.scss';
import AccountInfo from '../AccountInfo';
import AccountShip from '../AccountShip';
import AccountCard from '../AccountCard';
import AccountStatement from '../AccountMonthlyStatement';
import AccountSubusers from '../AccountSubusers';
import AccountPassword from '../AccountPassword';
import { Switch, Route } from 'react-router';
import AccountIncreaseCredit from '../AccountIncreaseCredit';
import UserUpdateInfo from 'src/components/UserUpdateInfo';

export interface IAccountContentProps {
  selected:
    | 'info'
    | 'ship'
    | 'card'
    | 'subusers'
    | 'password'
    | 'statement'
    | 'credit';
  match: any;
}

class AccountContent extends React.Component<IAccountContentProps, any> {
  public render() {
    return (
      <div className="rp-accountcontent">
        <Switch>
          <Route exact={true} path={`${this.props.match.path}`}>
            <AccountInfo />
          </Route>
          <Route path={`${this.props.match.path}/ship`}>
            <AccountShip />
          </Route>
          <Route path={`${this.props.match.path}/card`}>
            <AccountCard />
          </Route>
          <Route path={`${this.props.match.path}/statement`}>
            <AccountStatement />
          </Route>
          <Route path={`${this.props.match.path}/subusers`}>
            <AccountSubusers />
          </Route>
          <Route path={`${this.props.match.path}/creditlimit`}>
            <AccountIncreaseCredit />
          </Route>
          <Route path={`${this.props.match.path}/password`}>
            <AccountPassword />
          </Route>
          <Route path={`${this.props.match.path}/updateinfo`}>
            <UserUpdateInfo />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default AccountContent;
